import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from '@mui/material/CircularProgress';
import { useAppSelector, useAppDispatch } from "../../hooks";

import { ScenesItem, Icons, FloorItem, AvatarStyle } from './style'

import { GateType } from './store/types'
import './index.css'
import { handleCloseOpenGatesAsync, openCloseGGateAsync, selectGatesData, selectGateState } from "./store/Gates/gatesSlicer";
const GatesComponent = () => {

  const dispatch = useAppDispatch();

  const Gates = useAppSelector(selectGatesData)
  const gateState = useAppSelector(selectGateState)


  const handleGate = (gate: GateType) => {
    dispatch(openCloseGGateAsync(gate.id))
  }

  const handleLockAll = () => {
    dispatch(handleCloseOpenGatesAsync(false))
  }
  const handleUnlockAll = () => {
    dispatch(handleCloseOpenGatesAsync(true))
  }
  return (
    <Container maxWidth="lg">

      <Grid container spacing={4} sx={{ mt: 4 }} >
        <Grid sm={12} md={12}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
          >
            SCENES
          </Typography>
        </Grid>

        <Grid container md={12} spacing={{ md: 2 }}>
          <Grid md={3}>
            <ScenesItem onClick={handleLockAll}>
              <Avatar sx={AvatarStyle} src={Icons.GateClosedYellow} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Close All</Typography>
            </ScenesItem>
          </Grid>
          <Grid md={3}>
            <ScenesItem onClick={handleUnlockAll} >
              <Avatar sx={AvatarStyle} src={Icons.GateOpenedYellow} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Open All</Typography>
            </ScenesItem>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={4} sx={{ mt: 4 }} >
        <Grid ip={12} md={12}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
          >
            CONTROLS
          </Typography>
        </Grid>

        {
          !gateState.loading ?
            <Grid container md={12} spacing={{ md: 2 }}>
              {
                Gates.map((ele, i) => {
                  return (
                    <Grid key={i} md={3} >
                      <FloorItem onClick={() => handleGate(ele)}>
                        {gateState.gateLoading && gateState.selectedGate === ele.id ? <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} /> : <Avatar sx={{ width: 31, height: 31, marginLeft: "15px" }} src={ele.isOpened ? Icons.GateClosedWhite : Icons.GateOpenedYellow} />}

                        <div className="floors-text">
                          <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{ele.name} </Typography>
                          {gateState.gateLoading && gateState.selectedGate === ele.id ? <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}> Loading... </Typography>
                            :
                            <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}>{!ele.isOpened ? "CLOSED" : "OPENED"} </Typography>
                          }
                        </div>
                      </FloorItem>
                    </Grid>
                  )
                })
              }

            </Grid>
            :

            <Grid container md={12} spacing={{ md: 2 }}>
              {
                Gates.map((ele, i) => {
                  return (
                    <Grid key={i} md={3} >
                      <FloorItem>
                        <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} />
                        <div className="floors-text">
                          <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{ele.name} </Typography>
                          <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}> Loading... </Typography>
                        </div>
                      </FloorItem>
                    </Grid>
                  )
                })
              }

            </Grid>
        }

      </Grid>

    </Container>
  );
};

export default GatesComponent;
